import { render, staticRenderFns } from "./svg-exclamation.vue?vue&type=template&id=5dbe3dd6"
import script from "./svg-exclamation.vue?vue&type=script&lang=js"
export * from "./svg-exclamation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports